"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Merchant/CardInfoV2"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "merchant-v2",
  components: {
    CardInfo: _CardInfoV.default,
    BarChart: _BarChart.default
  },
  props: {
    data: Object,
    loading: Boolean,
    labels: Array,
    values: Array,
    httpAPI: Object,
    smppAPI: Object,
    redirectToDocs: Function,
    approvalStatus: Object,
    orgStatus: Object,
    numberOfDecimal: Number
  },
  computed: {
    cardInfo: function cardInfo() {
      if (Object.keys(this.data).length === 0) return;
      return [[{
        icon: 'fas fa-wallet',
        label: this.$t('dashboard.merchant.availableBalance'),
        value: parseFloat(this.data.processAvailableAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }, {
        icon: 'fas fa-coins',
        label: this.$t('dashboard.merchant.frozenAmount'),
        value: parseFloat(this.data.processFrozenAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }], [{
        icon: 'fas fa-envelope',
        label: this.$t('dashboard.merchant.uncreditedAmount'),
        value: parseFloat(this.data.processUncreditedAmount),
        decimal: true,
        // unit: this.$t('dashboard.merchant.smsUnit')
        numberOfDecimal: this.numberOfDecimal
      }, {
        icon: 'fas fa-receipt',
        label: this.$t('dashboard.merchant.totalRecharge'),
        value: parseFloat(this.data.processAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }]];
    }
  }
};
exports.default = _default;